
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const root = document.getElementById("smg-game-root");
    if (!root) return;

    const IMAGE_BASE = "https://portraits.seelenmatch.com/zodiac-r";
    const IMAGE_FALLBACK = "https://portraits.seelenmatch.com/zodiac-t";
    const TOTAL_ROUNDS = 6;

    const VALID_SIGNS = [
      "aries", "taurus", "gemini", "cancer", "leo", "virgo",
      "libra", "scorpio", "sagittarius", "capricorn", "aquarius", "pisces"
    ];

    const SERIES_LETTERS = {
      south: { m: ["A", "B", "C"], f: ["A"] },
      west:  { m: ["G", "H", "I"], f: ["G"] },
      north: { m: ["M", "N", "O"], f: ["M"] }
    };

    const ARCHETYPES = {
      winter_letter: {
        label: "The Winter Letter",
        description: "Calm, reserved, composed, stable and quietly emotional.",
        result: "Du reagierst besonders auf ruhige, stabile und emotional kontrollierte Präsenz."
      },
      southern_echo: {
        label: "The Southern Echo",
        description: "Warm, social, spontaneous, emotionally open and bright.",
        result: "Deine intuitive Resonanz nähert sich warmen, offenen und spontanen Energien."
      },
      hidden_lighthouse: {
        label: "The Hidden Lighthouse",
        description: "Protective, reliable, stable, strong without being dominant.",
        result: "Du scheinst besonders auf schützende, verlässliche und stabile Profile zu reagieren."
      },
      burning_horizon: {
        label: "The Burning Horizon",
        description: "Charismatic, adventurous, mobile and emotionally vivid.",
        result: "Intensive, charismatische und emotionale Präsenz erzeugt bei dir starke Resonanz."
      },
      forgotten_poet: {
        label: "The Forgotten Poet",
        description: "Sensitive, artistic, introspective and emotionally nuanced.",
        result: "Du reagierst stark auf sensible, introspektive und kreative Ausstrahlung."
      },
      gentle_storm: {
        label: "The Gentle Storm",
        description: "Intense but soft, passionate but emotionally warm.",
        result: "Leidenschaft und emotionale Wärme wirken bei dir gleichzeitig anziehend."
      },
      autumn_promise: {
        label: "The Autumn Promise",
        description: "Mature, stable, loyal and oriented toward the long term.",
        result: "Du suchst eher langfristige, loyale und stabile emotionale Dynamiken."
      },
      midnight_passenger: {
        label: "The Midnight Passenger",
        description: "Mysterious, nocturnal, less predictable and emotionally curious.",
        result: "Mysterium, Freiheit und emotionale Unvorhersehbarkeit ziehen dich besonders an."
      }
    };

    const SIGN_ARCHETYPES = {
      aries: "burning_horizon",
      taurus: "autumn_promise",
      gemini: "midnight_passenger",
      cancer: "hidden_lighthouse",
      leo: "southern_echo",
      virgo: "winter_letter",
      libra: "gentle_storm",
      scorpio: "gentle_storm",
      sagittarius: "burning_horizon",
      capricorn: "winter_letter",
      aquarius: "forgotten_poet",
      pisces: "forgotten_poet"
    };

    const ARCHETYPE_GROUPS = {
      warm: ["southern_echo", "burning_horizon"],
      deep: ["forgotten_poet", "midnight_passenger"],
      stable: ["winter_letter", "hidden_lighthouse", "autumn_promise"],
      intense: ["gentle_storm"]
    };

    const grid = document.getElementById("smg-grid");
    const result = document.getElementById("smg-result");
    const resultTitle = document.getElementById("smg-result-title");
    const resultText = document.getElementById("smg-result-text");
    const currentRoundEl = document.getElementById("smg-current-round");
    const totalRoundsEl = document.getElementById("smg-total-rounds");
    const progressFill = document.getElementById("smg-progress-fill");

    if (totalRoundsEl) totalRoundsEl.textContent = TOTAL_ROUNDS;

    let round = 1;
    let scores = {};
    let selectedPortraits = [];
    let selectedGenderMode = null;
    let userAge = 40;

    function randomItem(arr) {
      return arr[Math.floor(Math.random() * arr.length)];
    }

    function shuffle(arr) {
      const copy = arr.slice();

      for (let i = copy.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = copy[i];
        copy[i] = copy[j];
        copy[j] = tmp;
      }

      return copy;
    }

    function getClosestAges(age) {
      const n = parseInt(age, 10) || 40;

      if (n <= 34) return ["30", "40"];
      if (n <= 44) return ["40", "30"];
      if (n <= 54) return ["50", "40"];

      return ["60", "50"];
    }

    function getGender() {
      if (selectedGenderMode === "m") return "m";
      if (selectedGenderMode === "f") return "f";
      return Math.random() > 0.5 ? "m" : "f";
    }

    function getOriginFromArchetype(archetype) {
      switch (archetype) {
        case "burning_horizon":
        case "southern_echo":
          return "south";

        case "forgotten_poet":
        case "gentle_storm":
        case "midnight_passenger":
          return "west";

        default:
          return "north";
      }
    }

    function getGroupFromArchetype(archetype) {
      const groupNames = Object.keys(ARCHETYPE_GROUPS);

      for (let i = 0; i < groupNames.length; i++) {
        const group = groupNames[i];

        if (ARCHETYPE_GROUPS[group].includes(archetype)) {
          return group;
        }
      }

      return "other";
    }

    function getSignsByGroup(group) {
      return VALID_SIGNS.filter(function (sign) {
        return getGroupFromArchetype(SIGN_ARCHETYPES[sign]) === group;
      });
    }

    function generatePortrait(sign, forcedGender) {
      const archetype = SIGN_ARCHETYPES[sign];
      const gender = forcedGender || getGender();
      const age = randomItem(getClosestAges(userAge));
      const origin = getOriginFromArchetype(archetype);
      const letter = randomItem(SERIES_LETTERS[origin][gender]);
      const beauty = Math.random() > 0.5 ? "n" : "l";
      const filename = `${letter}-${sign}-${gender}-${age}-${origin}-${beauty}.png`;

      return {
        archetype,
        sign,
        gender,
        age,
        origin,
        letter,
        beauty,
        group: getGroupFromArchetype(archetype),
        filename,
        image: `${IMAGE_BASE}/${filename}`,
        fallback: `${IMAGE_FALLBACK}/${filename}`
      };
    }

    function hardVisualKey(portrait) {
      return [
        portrait.letter,
        portrait.gender
      ].join("-");
    }

    function softVisualKey(portrait) {
      return [
        portrait.archetype,
        portrait.gender,
        portrait.age,
        portrait.origin
      ].join("-");
    }

    function faceFamilyKey(portrait) {
      return [
        portrait.letter,
        portrait.age,
        portrait.origin
      ].join("-");
    }

    function generateRound() {
  
      const genderForRound = selectedGenderMode;

    const isFemaleOnly = selectedGenderMode === "f";

if (isFemaleOnly) {
  const FEMALE_ROUND_PLANS = [
    { letters: ["A", "G", "M"], age: "30", signs: ["capricorn", "aquarius", "pisces"], beauty: "n" },
    { letters: ["A", "G", "M"], age: "40", signs: ["aries", "taurus", "gemini"], beauty: "n" },
    { letters: ["A", "G", "M"], age: "30", signs: ["cancer", "leo", "virgo"], beauty: "l" },
    { letters: ["A", "G", "M"], age: "40", signs: ["libra", "scorpio", "sagittarius"], beauty: "n" },
    { letters: ["A", "G", "M"], age: "50", signs: ["capricorn", "aquarius", "pisces"], beauty: "n" },
    { letters: ["A", "G", "M"], age: "50", signs: ["aries", "taurus", "gemini"], beauty: "l" }
  ];

  const plan = FEMALE_ROUND_PLANS[(round - 1) % FEMALE_ROUND_PLANS.length];
  const chosenSigns = shuffle(plan.signs).slice(0, 3);

  return plan.letters.map(function(letter, index) {
    const sign = chosenSigns[index] || randomItem(plan.signs);
    const gender = "f";

    let origin = "north";
    if (letter === "A") origin = "south";
    if (letter === "G") origin = "west";
    if (letter === "M") origin = "north";

    const archetype = SIGN_ARCHETYPES[sign];

    const filename =
      `${letter}-${sign}-${gender}-${plan.age}-${origin}-${plan.beauty}.png`;

    return {
      archetype,
      sign,
      gender,
      age: plan.age,
      origin,
      letter,
      beauty: plan.beauty,
      group: getGroupFromArchetype(archetype),
      filename,
      image: `${IMAGE_BASE}/${filename}`,
      fallback: `${IMAGE_FALLBACK}/${filename}`
    };
  });
}

  const ALL_LETTERS = ["A", "B", "C", "G", "H", "I", "M", "N", "O"];

  const ROUND_PLANS = [
    { letters: ["A", "G", "M"], age: "30", signs: ["capricorn", "aquarius", "pisces", "aries", "taurus", "gemini"], beauty: "n" },
    { letters: ["B", "H", "N"], age: "40", signs: ["cancer", "leo", "virgo", "libra", "scorpio", "sagittarius"], beauty: "n" },
    { letters: ["C", "I", "O"], age: "30", signs: ["capricorn", "aquarius", "pisces", "aries", "taurus", "gemini"], beauty: "l" },
    { letters: ["A", "H", "O"], age: "40", signs: ["cancer", "leo", "virgo", "libra", "scorpio", "sagittarius"], beauty: "n" },
    { letters: ["B", "I", "M"], age: "30", signs: ["capricorn", "aquarius", "pisces", "aries", "taurus", "gemini"], beauty: "n" },
    { letters: ["C", "G", "N"], age: "40", signs: ["cancer", "leo", "virgo", "libra", "scorpio", "sagittarius"], beauty: "l" }
  ];

  const plan = ROUND_PLANS[(round - 1) % ROUND_PLANS.length];

  const alreadyChosenLetters = new Set(
    selectedPortraits.map(function(p) {
      return p.letter;
    })
  );

  let chosenLetters = plan.letters.filter(function(letter) {
    return !alreadyChosenLetters.has(letter);
  });

  if (chosenLetters.length < 3) {
    const extraLetters = shuffle(ALL_LETTERS).filter(function(letter) {
      return !alreadyChosenLetters.has(letter) && !chosenLetters.includes(letter);
    });

    chosenLetters = chosenLetters.concat(extraLetters);
  }

  if (chosenLetters.length < 3) {
    chosenLetters = shuffle(ALL_LETTERS).slice(0, 3);
  }

  chosenLetters = chosenLetters.slice(0, 3);

  const chosenSigns = shuffle(plan.signs).slice(0, 3);

  return chosenLetters.map(function(letter, index) {
    const sign = chosenSigns[index] || randomItem(plan.signs);
    const gender = genderForRound || getGender();

    let origin = "north";
    if (["A", "B", "C"].includes(letter)) origin = "south";
    if (["G", "H", "I"].includes(letter)) origin = "west";
    if (["M", "N", "O"].includes(letter)) origin = "north";

    const archetype = SIGN_ARCHETYPES[sign];

    const filename =
      `${letter}-${sign}-${gender}-${plan.age}-${origin}-${plan.beauty}.png`;

    return {
      archetype,
      sign,
      gender,
      age: plan.age,
      origin,
      letter,
      beauty: plan.beauty,
      group: getGroupFromArchetype(archetype),
      filename,
      image: `${IMAGE_BASE}/${filename}`,
      fallback: `${IMAGE_FALLBACK}/${filename}`
    };
  });
}


    function updateProgress() {
      if (currentRoundEl) currentRoundEl.textContent = round;

      if (progressFill) {
        progressFill.style.width = ((round - 1) / TOTAL_ROUNDS) * 100 + "%";
      }
    }

    function renderRound() {
      updateProgress();

      if (!grid) return;

      grid.innerHTML = "";

      const portraits = generateRound();

      portraits.forEach(function (portrait) {
        const card = document.createElement("button");

        card.type = "button";
        card.className = "smg-card";

        card.innerHTML = `
          <img
            src="${portrait.image}"
            alt="Seelenmatch Portrait"
            loading="lazy"
          >
        `;

        const img = card.querySelector("img");

        img.onerror = function () {
          if (img.src !== portrait.fallback) {
            img.src = portrait.fallback;
          }
        };

        card.addEventListener("click", function () {
          scores[portrait.archetype] = (scores[portrait.archetype] || 0) + 1;
          selectedPortraits.push(portrait);

          if (round >= TOTAL_ROUNDS) {
            showResult();
          } else {
            round += 1;
            renderRound();
          }
        });

        grid.appendChild(card);
      });
    }

    function getDominantArchetype() {
      let best = null;
      let bestScore = -1;

      Object.keys(scores).forEach(function (key) {
        if (scores[key] > bestScore) {
          best = key;
          bestScore = scores[key];
        }
      });

      return best || "hidden_lighthouse";
    }

    function buildRevealHTML(dominant) {
      let html = `
        <div class="smg-slow-reveal">
          <div class="smg-reveal-title">
            Deine ausgewählten Portraits
          </div>
          <div class="smg-reveal-grid">
      `;

      selectedPortraits.forEach(function (portrait, index) {
        const archetype = ARCHETYPES[portrait.archetype];
        const isWinner = portrait.archetype === dominant;

        html += `
          <div class="smg-reveal-card ${isWinner ? "is-winner" : ""}" style="animation-delay:${index * 0.22}s">
            <img src="${portrait.image}" alt="${archetype.label}" loading="lazy" onerror="this.src='${portrait.fallback}'">

            <div class="smg-reveal-name">
              ${archetype.label}
            </div>

            <div class="smg-reveal-desc">
              ${archetype.description}
            </div>
          </div>
        `;
      });

      html += `
          </div>
          <div class="smg-winner-box">
            <div class="smg-winner-label">Am häufigsten gewählt</div>
            <div class="smg-winner-name">${ARCHETYPES[dominant].label}</div>
          </div>
        </div>
      `;

      return html;
    }

    function injectRevealStyles() {
  if (document.getElementById("smg-reveal-dynamic-styles")) return;

  const style = document.createElement("style");
  style.id = "smg-reveal-dynamic-styles";

  style.textContent = `
    .smg-slow-reveal{
      margin:28px auto 0;
      max-width:900px;
    }

    .smg-reveal-title{
      font-size:18px;
      font-weight:800;
      margin-bottom:18px;
      text-align:center;
    }

    .smg-reveal-grid{
      display:grid;
      grid-template-columns:repeat(3,minmax(0,1fr));
      gap:16px;
    }

    .smg-reveal-card{
      background:#fff;
      border:1px solid rgba(0,0,0,.08);
      border-radius:20px;
      overflow:hidden;
      box-shadow:0 10px 28px rgba(0,0,0,.06);
      opacity:0;
      transform:translateY(18px) scale(.98);
      animation:smgRevealIn .65s ease forwards;
    }

    .smg-reveal-card.is-winner{
      border:3px solid #d81b60;
      box-shadow:0 18px 46px rgba(216,27,96,.22);
    }

    .smg-reveal-card img{
      width:100%;
      aspect-ratio:3/4;
      object-fit:cover;
      display:block;
    }

    .smg-reveal-name{
      padding:12px 12px 4px;
      font-size:15px;
      font-weight:900;
      text-align:center;
    }

    .smg-reveal-desc{
      padding:0 12px 14px;
      font-size:12px;
      line-height:1.45;
      color:#666;
      text-align:center;
    }

    .smg-winner-box{
      margin:24px auto 0;
      padding:20px;
      max-width:520px;
      border-radius:22px;
      background:#fff5f8;
      border:1px solid rgba(216,27,96,.18);
      text-align:center;
    }

    .smg-winner-label{
      font-size:12px;
      font-weight:900;
      letter-spacing:.08em;
      color:#c92464;
      text-transform:uppercase;
      margin-bottom:6px;
    }

    .smg-winner-name{
      font-size:28px;
      font-weight:900;
      color:#171717;
    }

    /* --- RESULT BUTTONS --- */

    .smg-result-actions{
      display:flex;
      justify-content:center;
      gap:14px;
      flex-wrap:wrap;
      margin-top:28px;
    }

    .smg-result-btn,
    .smg-result-btn:visited,
    .smg-result-btn:hover{
      display:inline-flex;
      align-items:center;
      justify-content:center;
      min-height:48px;
      padding:0 24px;
      border-radius:999px;
      background:#d63384;
      color:#fff !important;
      text-decoration:none !important;
      font-weight:800;
      font-size:14px;
      box-shadow:0 10px 26px rgba(214,51,132,.18);
    }

    .smg-result-btn-secondary,
    .smg-result-btn-secondary:visited,
    .smg-result-btn-secondary:hover{
      background:#111;
      color:#fff !important;
    }

    @keyframes smgRevealIn{
      to{
        opacity:1;
        transform:translateY(0) scale(1);
      }
    }

    @media(max-width:800px){

      .smg-reveal-grid{
        grid-template-columns:1fr;
      }

      .smg-result-actions{
        flex-direction:column;
        align-items:center;
      }

      .smg-result-btn{
        width:100%;
        max-width:280px;
      }
    }
  `;

  document.head.appendChild(style);
    }

    function showResult() {
      if (grid) grid.innerHTML = "";

      if (progressFill) {
        progressFill.style.width = "100%";
      }

      const dominant = getDominantArchetype();
      const profile = ARCHETYPES[dominant];

      injectRevealStyles();

      if (resultTitle) resultTitle.textContent = profile.label;


if (resultText) {
  resultText.innerHTML = `
    ${profile.result}
    ${buildRevealHTML(dominant)}

    <div class="smg-result-actions">

      <a class="smg-result-btn smg-result-btn-secondary" href="/">
        Go to homepage
      </a>

      <a class="smg-result-btn" href="/pages/seelenmatch-game">
        Play again
      </a>

      <a class="smg-result-btn smg-result-btn-secondary" href="/pages/seelenmatch-subscription">
        Continue to membership
      </a>

    </div>
  `;
}

if (result) result.hidden = false;



      try {
        localStorage.setItem(
          "sm_game_result_v2",
          JSON.stringify({
            archetype: dominant,
            scores,
            selectedPortraits,
            genderMode: selectedGenderMode,
            userAge,
            date: new Date().toISOString()
          })
        );
      } catch(e) {}

      if (result) {
        result.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    }

    const genderButtons = document.querySelectorAll("[data-smg-gender]");

    genderButtons.forEach(function(btn) {
      btn.addEventListener("click", function() {
        selectedGenderMode = btn.dataset.smgGender;

        const chooser = document.getElementById("smg-gender-choice");
        if (chooser) chooser.style.display = "none";

        const playArea = document.getElementById("smg-play-area");
        if (playArea) {
          playArea.hidden = false;
          playArea.style.display = "block";
        }

        round = 1;
        scores = {};
        selectedPortraits = [];

        if (result) result.hidden = true;

        renderRound();
      });
    });
  });
})();